const ITEMS = [
  "Off-Market Opportunities",
  "Automatic Matching",
  "Private Messaging",
  "Worldwide Network",
  "Verified Prime Agents Only",
  "In-App Split Negotiation",
  "Saved Agents & Referrals",
  "Zero Public Portal Leakage",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item, i) => (
      <span key={i} className="flex items-center">
        <span className="font-display italic text-xl sm:text-2xl text-[#141518] px-8 whitespace-nowrap">
          {item}
        </span>
        <span className="font-eyebrow text-[10px] text-[#B89B6C]">&middot;</span>
      </span>
    ))}
  </div>
);

export const EditorialMarquee = () => (
  <div
    data-testid="editorial-marquee"
    className="border-y border-[#E7E4DC] py-6 overflow-hidden bg-[#F3F1EB]"
  >
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
  </div>
);
